// Podwórko 1.5x wide (spec 2026-10-22): the garage block moved `shift` game px right; `cut_x` = its
// left wall per Podwórko level. Mirror of backend/app/game/backyard_wide.json (v19 migration), kept as
// a JS literal so plain `node --test` can import it; backyardWide.test.mjs pins them equal.
export const BACKYARD_WIDE = { shift: 640, cut_x: { 1: 985, 2: 845, 3: 845, 4: 845, 5: 735 } };
